import { overridesSchema } from '@bos/feature-toggles';
import { z } from 'zod';

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		__ENV: unknown;
	}
}

const environmentSchema = z.enum(['local', 'dev', 'test', 'stage', 'prod']);
export type Environment = z.infer<typeof environmentSchema>;

const runsInSchema = z.enum(['BANK', 'FIP']);
export type RunsIn = z.infer<typeof runsInSchema>;

const envSchema = z.object({
	CLIENT_ENVIRONMENT: environmentSchema,
	CLIENT_RUNS_IN: runsInSchema,

	CLIENT_WSO2_EXTERNAL_URL: z.string(),
	CLIENT_WSO2_INTERNAL_URL: z.string(),

	CLIENT_TOKEN_REFRESH_ENDPOINT: z.string(),

	CLIENT_SENTRY_DSN: z.string().optional(),

	CLIENT_FEATURE_TOGGLES_OVERRIDE: overridesSchema.optional(),

	CLIENT_ZENID_URL: z.string().optional(),

	CLIENT_ZENID_SAMPLE_URL: z.string().optional(),

	CLIENT_DCS_ACCOUNT_URL: z.string().optional(),

	CLIENT_DYNATRACE_URL: z.string().optional(),

	CLIENT_DCS_BACKOFFICE_URL: z.string().optional(),

	CLIENT_BANK_FORECLOSURES_URL: z.string().optional(),

	CLIENT_ISSUER_URL: z.string(),
	CLIENT_CLIENT_ID: z.string(),
	CLIENT_PID_KEYCLOAK_IDP_HINT: z.string(),
	CLIENT_RESOURCE_SERVER: z.string(),

	CLIENT_ADJUST_DEEPLINK_TOKEN: z.string().optional(),
	CLIENT_ADJUST_DEEPLINK_HOST_DOMAIN: z.string().optional(),

	CLIENT_FIP_DEV_LOGIN_USERNAME: z.string().optional(),
	CLIENT_FIP_DEV_LOGIN_PASSWORD: z.string().optional(),

	CLIENT_E2E_MODE: z.string().optional(),
	CLIENT_E2E_LOGIN_USERNAME: z.string().optional(),
	CLIENT_E2E_LOGIN_PASSWORD: z.string().optional(),
});

export const env = envSchema.parse(window.__ENV);
